<template>
	<div>
		<div class="w-tabs">
			<div class="tabs">
				<div class="tab active" @click="showDlg" v-if="addFlag">新建复诊</div>
				<div></div>
				<a v-if="registerUrl.flag" class="rigActive" :href="registerUrl.url"
					target="_blank">{{registerUrl.name}}</a>
			</div>
		</div>
		<div class="table-wrap">
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
				:data="list.data" v-loading="isLoading" @selection-change="selectionChange">

				<el-table-column label="预约复诊日期" width="140">
					<template slot-scope="scope">{{ scope.row.appointmentDate }}</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip></el-table-column>
				<el-table-column prop="creator" label="创建人" width="120"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
				<el-table-column label="复诊状态" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.returnVisitState == 0">待复诊</span>
						<span v-if="scope.row.returnVisitState == 1">已复诊</span>
						<span v-if="scope.row.returnVisitState == 2">未履约</span>
						<span v-if="scope.row.returnVisitState == 3">已重约</span>

					</template>
				</el-table-column>
				<el-table-column prop="returnVisitDate" label="实际复诊日期" width="160" show-overflow-tooltip>
						<template slot-scope="scope">
							{{ scope.row.returnVisitDate?scope.row.returnVisitDate:'尚未复诊'}}
						</template>
					</el-table-column>
				<el-table-column prop="manualStateStr" label="人工提醒" show-overflow-tooltip></el-table-column>
				<el-table-column prop="smsAutoStateStr" label="自动提醒" show-overflow-tooltip></el-table-column>

				<el-table-column label="操作" width="140">
					<template slot-scope="scope">
						<div class="tab-action">
							<!-- <template v-if="scope.row.returnVisitState > 0">
							<el-tooltip content="查看" placement="top" :enterable="false"><router-link :to="{name: 'Patient/GroupView'}"><i class="icon-research"></i></router-link></el-tooltip>
							</template> -->
							<template v-if="scope.row.returnVisitState ==2">
								<el-tooltip content="重约" placement="top" :enterable="false"><i class="icon-edit"
										@click="showDlg(scope.row,'recontract')"></i></el-tooltip>
							</template>
							<template v-if="scope.row.returnVisitState !== 3&&scope.row.returnVisitState !==2">
								<el-tooltip content="提醒" placement="top" :enterable="false"><i
										v-if="scope.row.returnVisitState == 0||scope.row.returnVisitState == 3"
										class="el-icon-bell" @click="showDlg(scope.row,'warning')"></i></el-tooltip>
								<el-tooltip content="修改" v-if="scope.row.returnVisitState !=1" placement="top" :enterable="false"><i class="icon-edit"
										@click="showDlg(scope.row)"></i></el-tooltip>
								<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
									<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i
											class="el-icon-delete"></i></el-tooltip>
								</el-popconfirm>
							</template>
						</div>
					</template>
				</el-table-column>

			</el-table>
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
								v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
							:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
							:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
							@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog :title="flag=='warning'?'人工提醒方式':form.id > 0? '修改复诊' : '新建复诊'" width="530px"
			:visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item v-if="flag=='warning'">
					<el-checkbox-group v-model="checkboxGuid" @change="handleCheckbox">
						<el-checkbox label="smsManualState">短信提醒</el-checkbox>
						<el-checkbox label="phoneManualState">电话提醒</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="复诊日期" prop="appointmentDate" v-if="flag!='warning'">
					<el-date-picker size="small" style="width:220px" type="date" align="right" :clearable="false"
						v-model="form.appointmentDate" :picker-options="pickerOptions"></el-date-picker>
				</el-form-item>
				<el-form-item label="温馨提示（患者短信可见）" v-if="flag!='warning'">
					<el-input size="mini" type="textarea" style="width: 80%" rows="5" resize="none"
						v-model="form.remark"></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import mixin from '@/views/mixin';
	import dayjs from 'dayjs';

	export default {
		mixins: [mixin],
		props: {
			recordId: {
				require: true
			},
			datasources:{
				default:''
			}
		},
		data() {
			return {
				noSidebar: true,
				dlg: {
					active: false,
					rules: {
						appointmentDate: {
							required: true,
							message: '请选择'
						},
					}
				},
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null
				},
				filter: {
					patientId: 0,
					recordId: '',
					pageNumber: 1,
					pageSize: 10
				},
				form: {
					patientId: 0,
					recordId: '',
					returnVisitState: 0,
					appointmentDate: '',
					datasources:''
				},
				hospitalCode: 'YS_HM4',
				flag: '',
				checkboxGuid: [],
				pickerOptions: {
					// 禁用当天和之前的日期
					disabledDate: time=>{return time.getTime() < Date.now();},
					shortcuts:null
				},
				registerUrl:{
					flag:false,
					name:"预约挂号",
					url:""
				},
				addFlag:true,
				patientInfo:{},
			}
		},
		created() {
			this.init();
		},
		mounted() {
			// 监听页面显示隐藏
			document.addEventListener('visibilitychange', this.handleVisiable)
			this.form.datasources=this.datasources?this.datasources:this.$route.query.datasources;
		},
		destroyed() {
			document.removeEventListener('visibilitychange', this.handleVisiable)
		},
		methods: {
			async init() {
				this.hospitalCode = await api.getHospitalCode();
				this.patientId = +this.$route.query.patientId;
				this.filter.patientId = this.patientId;
				this.filter.recordId = this.$route.query.fid || this.recordId;
				this.form.patientId = this.patientId;
				this.form.recordId = this.filter.recordId;
				await this.loadList();
				if (this.hospitalCode == 'FJ_YX1' || this.hospitalCode == 'YS_HM4'||this.hospitalCode == 'FJ_SM2') {
					await this.loadPatientDetail();
				}
			},
			async getRegisterUrl(){
				this.registerUrl = await api.getRegisterUrl();
				let user=JSON.parse(localStorage.getItem("user")).data;
				if(this.hospitalCode == 'FJ_SM2'|| this.hospitalCode == 'YS_HM4'){
					this.registerUrl.url=this.registerUrl.url.replace('idNo=${}', `idNo=${this.patientInfo.cardNum}`).replace('idUserCode=${}', `idUserCode=${user.user.hisId}`); 
				}else if (this.hospitalCode == 'FJ_YX1'){
					this.registerUrl.url=this.registerUrl.url.replace('name=${}', `name=${this.patientInfo.name}`).replace('idCard=${}', `idCard=${this.patientInfo.cardNum}`).replace('phone=${}', `phone=${this.patientInfo.phone}`);
				}
				console.log( this.registerUrl.url,'------registerUrl.url--')
			},
			async loadList() {
				this.isLoading = true;
				let res = await api.getSubsequentVisitListByRecordId(this.filter);
				if (res.code == 500) {
					return;
				}

				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				// if (res.data) {
				// 	res.data.forEach((item) => {
				// 		item.appointmentDate = dayjs(item.appointmentDate).format('YYYY-MM-DD');
				// 	})
				// 	
				// }
				this.addFlag = true;
				res.data.forEach((item) => {
					item.appointmentDate = dayjs(item.appointmentDate).format('YYYY-MM-DD');
						if(res.data.length > 0 && item.returnVisitState != 3){
							//如果有复诊数据，且状态不是已重约，就隐藏新建复诊按钮
							this.addFlag = false;
						}
				})
				this.list.data = res.data;
				this.isLoading = false;
			},
			async loadPatientDetail() {
				let res = await api.getPatient({
					patientId: this.patientId
				});
				this.patientInfo = res.data;
				if (res.code == 500) {
					return;
				}
				this.getRegisterUrl()
				
			},
			showDlg(item, flag) {
				this.dlg.active = true;
				this.flag = flag;
				if (flag == 'warning') {
					if (item.phoneManualState == 1 && item.smsManualState == 0) {
						this.checkboxGuid.push('phoneManualState');
					} else if (item.smsManualState == 1 && item.phoneManualState == 0) {
						this.checkboxGuid.push('smsManualState');
					} else if (item.phoneManualState == 1 && item.smsManualState == 1) {
						this.checkboxGuid = ['phoneManualState', 'smsManualState']
					} else {
						this.checkboxGuid = [];
					}
					console.log(item.phoneManualState, item.smsManualState, '-----item');
				}
				if (item.id > 0) {//修改复诊
					this.form.id = item.id;
					this.form.appointmentDate = item.appointmentDate;//2025-5-8改
					// const now = dayjs();
					// this.form.appointmentDate=now.format('YYYY-MM-DD HH:mm:ss');

				} else {
					delete this.form.id;
					this.$nextTick(() => {
						this.$refs['form'].resetFields();
					});
				}
			},
			closeDlg() {
				this.dlg.active = false;
			},
			handleCheckbox() {
				console.log('checkbox', this.checkboxGuid);
			},
			saveForm() {
				let res;
				this.$refs['form'].validate(async (valid) => {
					if (valid) {
						// recontractSubsequentVisit
						this.isLoading = true;
						this.form.appointmentDate = dayjs(this.form.appointmentDate).format(
							'YYYY-MM-DD HH:mm:ss');
						if (this.flag == 'recontract') {
							res = await api.recontractSubsequentVisit(this.form);
						} else if (this.flag == 'warning') {

							let obj = {
								id: this.form.id,
								phoneManualState: this.checkboxGuid.indexOf('phoneManualState') < 0 ? 0 :
									1,
								smsManualState: this.checkboxGuid.indexOf('smsManualState') < 0 ? 0 : 1,
							}
							res = await api.editReVisitManual(obj);
						} else {
							if (this.form.id > 0) {
								res = await api.editSubsequentVisit(this.form);
							} else {
								res = await api.addSubsequentVisit(this.form);
							}
						}
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.closeDlg();
						this.loadList();
						this.$message.success('保存成功');
					}
				});
			},
			async delItem(item) {
				this.isLoading = true;
				let res = await api.delSubsequentVisit({
					id: item.id
				});
				this.isLoading = false;
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.loadList();
				this.$message.success('已删除');
			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			},
			handleVisiable(e) {
				// 关闭新开页面，回到列表页，刷新列表数据
				if (e.target.visibilityState == "visible") {
					this.init();
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';

	/deep/.el-dialog__body {
		padding: 30px 20px 0;
	}

	.w-tabs {
		>.tabs {
			padding: 20px 30px;
			justify-content: space-between;
		}
	}

	.table-wrap {
		margin-left: 0;
		margin-right: 0;
	}

	.rigActive {
		color: @fckey;
		cursor: pointer;
	}

	.rigActive:not(.noline):hover {
		text-decoration: none;
	}
</style>